import Modal from 'react-bootstrap/Modal';
import { useAppDispatch, useAppSelector } from "../../../services/hooks.ts";
import { fetchInit } from "../../../stores/user/userSlice.ts";
import { useEffect, useState } from "react";
import getApiUrl from "../../../api/ApiUrl.tsx";
import { useTranslation } from "react-i18next";
export default function LoginModal({ success, show, setShow }: any) {
    const { t } = useTranslation('cart');
    const dispatch = useAppDispatch();
    const lang = useAppSelector((state) => state.user.language);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const onSubmit = async (e: any) => {
        e.preventDefault();

        if (!e.target.checkValidity()) return false;

        setErrorMessage(null);
        setLoading(true);

        const request = await fetch(getApiUrl() + '/login', { method: 'POST', body: new FormData(e.target) });
        const response = await request.json();
        if (!response.error) {
            await dispatch(fetchInit());
            success();
        } else {
            setErrorMessage(response.info);
        }

        setTimeout(() => {
            setLoading(false);
        }, 1000);

        return false;
    }

    useEffect(() => {
        console.log('show', show);
    }, [show])

    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{t('loginModal.title')}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <form className="needs-validation" noValidate={false} id="loginForm" action="/api/login"
                    method="post" onSubmit={onSubmit}>
                    <div className="row gap-4">
                        <p className={'text-center'}>
                            {t('loginModal.needAccount')}
                        </p>
                        <div className="col-12 position-relative">
                            <label htmlFor="validationLoginMail" className="form-label-basket">{t('loginModal.emailLabel')}</label>
                            <input type="text"
                                className="form-control rounded-3 focus-ring focus-ring-warning border-secondary-subtle"
                                id="validationLoginMail" autoComplete="email" placeholder="Wprowadź adres e-mail"
                                name="login" required={true} />

                            <div className="invalid-feedback">
                                {t('loginModal.emailInvalid')}
                            </div>
                            <div id="ajaxResponseMessage" className="col-12" style={{ "height": "10px" }}></div>
                        </div>
                        <div className="col-12 position-relative">
                            <label htmlFor="validationLoginPass" className="form-label-basket">{t('loginModal.passwordLabel')}</label>
                            <input type="password"
                                className="form-control rounded-3 focus-ring focus-ring-warning border-secondary-subtle"
                                id="validationLoginPass" autoComplete="password" placeholder="Wprowadź hasło"
                                name="passwd" required={true} />
                            <a className="btn w-auto mx-auto d-block rounded-3"
                                href={`/lang-${lang}/reset-password/`}>
                                {t('loginModal.passwordForgot')}
                            </a>
                            <div className="invalid-feedback">
                                {t('loginModal.passwordInvalid')}
                            </div>
                            {errorMessage ? <div id="loginErrorMessage" className="text-danger">
                                {t('loginModal.error')}
                                {errorMessage}
                            </div> : ''}
                        </div>
                        <div className="col-12 align-items-center text-center">
                            <button type="submit" className="btn btn-success rounded-3" disabled={loading}>{t('loginModal.logIn')}
                            </button>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className={'d-block text-center'}>
                {t('loginModal.noAccount')} <a href={'/register'} className="btn btn-sm btn-outline-primary">{t('loginModal.register')}</a>
            </Modal.Footer>
        </Modal>
    );
}